export class HUD {
  constructor() {
    this.els = {
      score: document.getElementById('score'),
      coins: document.getElementById('coins'),
      speed: document.getElementById('speed'),
      overlay: document.getElementById('overlay'),
      pauseOverlay: document.getElementById('pause-overlay'),
      gameover: document.getElementById('gameover-overlay'),
      finalScore: document.getElementById('final-score'),
      finalCoins: document.getElementById('final-coins'),
      magnet: document.getElementById('magnet-badge'),
      board: document.getElementById('board-badge'),
      powers: document.getElementById('powers'),
    };
  }

  bind(game) {
    document.getElementById('start-btn').onclick = () => game.start();
    document.getElementById('resume-btn').onclick = () => game.resume();
    document.getElementById('restart-btn').onclick = () => game.start();
    document.getElementById('again-btn').onclick = () => game.start();
    document.getElementById('pause-btn').onclick = () => game.togglePause();
  }

  showPlaying() {
    this.els.overlay.classList.add('hidden');
    this.els.pauseOverlay.classList.add('hidden');
    this.els.gameover.classList.add('hidden');
    this.els.powers.classList.remove('hidden');
  }

  showPaused() {
    this.els.pauseOverlay.classList.remove('hidden');
  }

  showGameOver(score, coins) {
    this.els.finalScore.textContent = String(score);
    this.els.finalCoins.textContent = String(coins);
    this.els.gameover.classList.remove('hidden');
    this.els.pauseOverlay.classList.add('hidden');
  }

  update(game) {
    this.els.score.textContent = String(game.score);
    this.els.coins.textContent = String(game.coins);
    this.els.speed.textContent = game.player.forwardSpeed.toFixed(1);
    this.els.magnet.classList.toggle('hidden', !game.powers.magnetActive);
    const boardVis = game.powers.boardActive || game.powers.hoverboardAvailable;
    this.els.board.classList.toggle('hidden', !boardVis);
    this.els.board.textContent = game.powers.boardActive
      ? 'BOARD'
      : game.powers.hoverboardAvailable
        ? 'REVIVE'
        : 'BOARD';
  }
}
